import * as yup from 'yup';
import ValidationMessage from '../../constants/ValidationMessage';

const DoNotSellValidation: any = yup.object().shape({
    name: yup.string().required(ValidationMessage.Field("your name"))
        .min(2, ValidationMessage?.MinLength("Your name", 2))
        .max(25, ValidationMessage?.MaxLength("Your name", 25)),

    email: yup.string().required(ValidationMessage.Field("email"))
        .email(ValidationMessage.EMAIL_ADDRESS)
        .matches(ValidationMessage.EMAIL_REGREX, ValidationMessage.EMAIL_ADDRESS)
        .max(150, ValidationMessage.MaxLength('Email', 150))
        .trim(),

    country: yup.string().required(ValidationMessage.SelectField("a country")),
    state: yup.string().required(ValidationMessage.SelectField("a state")),
});

export default DoNotSellValidation;
